import { render } from "./AccountEdit.vue?vue&type=template&id=a9cd7bf8&scoped=true"
import script from "./AccountEdit.vue?vue&type=script&lang=js"
export * from "./AccountEdit.vue?vue&type=script&lang=js"

import "./AccountEdit.vue?vue&type=style&index=0&id=a9cd7bf8&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9cd7bf8"]])

export default __exports__